import '@ungap/with-resolvers';
import { StrictMode } from 'react';
import SigmaDeviceManager from '@socure-inc/device-risk-sdk';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Router from 'routes';
import { store } from 'stores';
import setupAxiosInterceptor from 'utils/axiosInterceptor';
import { initializeSentry } from 'utils/sentry';
import 'index.scss';
import 'react-toastify/dist/ReactToastify.css';

const container = document.getElementById('root')!;
const root = createRoot(container);

const socureSdkKey = import.meta.env.VITE_SOCURE_SDK_KEY;

// Initialize Sentry
initializeSentry();

// Initialize Sigma Device Manager
SigmaDeviceManager.initialize({
  sdkKey: socureSdkKey as string,
});

setupAxiosInterceptor();

root.render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Router />
        <ToastContainer position="bottom-left" />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
